import React from 'react';
import { Select, SelectItem, SelectGroup, } from '@ui-kitten/components';
export const Kitten = (props) => {
    const { children, ...rest } = props;
    return (<Select {...rest}>
      {children}
    </Select>);
};
Kitten.Item = SelectItem;
Kitten.Group = SelectGroup;
export { SelectItem, SelectGroup, Select };
export default Kitten;
//# sourceMappingURL=Select.js.map